import React, { Component, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
// import Dropzone from 'react-dropzone';
// import logo from './logo.svg';
import './css/styles.css';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import LocalizedStrings from 'react-localization';
import Localizations from './localizations.js';
import LanguageMenu from './LanguageMenu.js';
import PrivacyPolicyDialog from './PrivacyPolicyDialog';

// import CloudUploadIcon from '@material-ui/icons/CloudUploadOutlined';
// import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFileOutlined';
// import CancelIcon from '@material-ui/icons/Cancel';
// import CheckBoxIcon from '@material-ui/icons/CheckBox';
// import CloseIcon from '@material-ui/icons/Close';
// import CheckCircle from '@material-ui/icons/CheckCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import ArrowBack from '@material-ui/icons/ArrowBack';
import SubdirectoryArrowRight from '@material-ui/icons/SubdirectoryArrowRight';
// import CheckIcon from '@material-ui/icons/Done';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheckSquare, faTimes, faCheck, faFilePdf, faArrowLeft, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

// import StudyoLogo from './studyo.png';
import HaagaHeliaLogo from './img/haaga-helia-logo.jpg';
import HaagaHeliaLogoEn from './img/haaga-helia-logo-en.png';
import HamkLogo from './img/hamk.jpg';
import LaureaLogoFi from './img/laurea-logo.fi.png';
import LaureaLogoEn from './img/laurea-logo.en.png';
import OamkLogoFi from './img/oamk-logo.jpg';
import OamkLogoEn from './img/oamk-logo-en.jpg';
import AtomiLogo from './atomi-validator-logo-teksti.png';
import UploadLogo from './upload.png';
import PoweredBy from './powered-by-studyo.png';
import LoaderImg from './img/atomi-loader.png';
import KamkLogoFi from './img/kamk-logo.jpg';
import KamkLogoEn from './img/kamk-logo-en.jpg';
import XamkLogo from './img/xamk-logo.png';
import TamkLogo from './img/tamk-logo.png';
import SeamkLogo from './img/seamk-logo.jpg';
import LapinAMKLogo from './img/lapinamk-logo.jpg';
import turkuAMKLogo from './img/turkuamk-logo.jpg';
import CentriaLogo from './img/centria.jpg';
import LABLogo from './img/lab.jpg';

import NoviaLogoSv from './img/novia_logo_sv.jpg';
import NoviaLogoEn from './img/novia_logo_en.jpg';

import AboLogoSv from './img/abo_logo_sv.png';
import AboLogoEn from './img/abo_logo_en.png';

import VamkLogo from './img/vamklogoblack.jpg';
import JamkLogo from './img/jamk_logo.jpg';

import HumakLogo from './img/humak-logo.jpg';

import KareliaLogo from './img/karelia-logo.jpg';
import DVVLogo from './img/dvv-logo.png';
import HyriaLogo from './img/hyria-logo.jpg';
import SavoniaLogo from './img/savonia-logo.jpg';
import SamkLogo from './img/samk-logo.jpg';
import OuluyoLogo from './img/ouluyo-logo.png';
import UniartsLogo from './img/uniarts.jpg';
import DIAKLogo from './img/diak-logo.png';
import UEFLogo from './img/uef-logo.png';
import UlaplandLogo from './img/ulapland-logo.png';
import UwasaLogo from './img/uwasa-logo.jpg';
import BCLogo from './img/bc_logo.png';
import LuksiaLogo from './img/luksia-logo.jpg';
import OmniaLogo from './img/omnia-logo.png';
import SamieduLogo from './img/samiedu_logo.png';
import EseduLogo from './img/esedu-logo.jpg';
import LappiaLogo from './img/lappia.jpg';

// import { red } from '@material-ui/core/colors';

let strings = new LocalizedStrings(Localizations);
const urlParams = new URLSearchParams(window.location.search);

if(urlParams.get('lang') == 'en') {
  strings.setLanguage('en');
} else if(urlParams.get('lang') == 'sv') {
  strings.setLanguage('sv');
} 
else if(urlParams.get('lang') == 'fi') {
  strings.setLanguage('fi');
}else {
  strings.setLanguage('fi');
}

const studyoUrl = 'https://studyo.fi';
const mainColor = '#006699';

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  appName: {
    margin: '0 auto',
    fontFamily: 'Nasalization, sans-serif',
    fontSize: '1.8rem',
    textAlign: 'center'
  },
  appLogo: {
    height: '60px',
    marginTop: '6px'
  },
  naviLeft: {
    width: '20%',
    fontSize: '2rem'
  },
  validateButton: {
    backgroundColor: mainColor,
    width: '100%',
    maxWidth: '500px',
    fontFamily: 'Montserrat',
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    textTransform: 'none'
  },
  disabledButton: {
    backgroundColor: 'rgba(68, 147, 255, 0.32) !important',
    border: '1px solid rgb(34,96,181, 0.2)',
    boxShadow: 'none',
    width: '100%',
    maxWidth: '600px',
    fontFamily: 'Montserrat',
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    textTransform: 'none',
    color: '#fff !important'
  },
  validateAgainButton: {
    backgroundColor: mainColor,
    width: '100%',
    maxWidth: '500px',
    fontFamily: 'Montserrat',
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    textTransform: 'none',
    marginBottom: '1rem'
  },
  validatorWrapper: {
    maxWidth: '500px',
    width: '90%',
    margin: '0 auto',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    flexGrow: '2'
  },
  resultsWrapper: {
    maxWidth: '500px',
    width: '90%',
    margin: '0 auto',
    textAlign: 'left',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: '1.2rem'
  },
  resultText: {
    fontSize: '1.2rem',
    display: 'inline-block',
    width: '84%',
    verticalAlign: 'middle',
    marginLeft: '9px',
    fontWeight: '500',
  },
  infotext1: {
    color: 'rgba(36,36,36,84)',
    fontSize: '1.2rem',
    margin: '2rem 0',
    fontWeight: '500'
  },
  infotext2: {
    color: 'rgba(36,36,36,84)',
    fontSize: '1rem',
    margin: '1rem auto 1rem',
    fontWeight: '500',
    maxWidth: '500px',
    textAlign: 'left'
  },
  header: {
    background: mainColor
  },
  poweredby: {
    fontFamily: 'Athelas',
    fontSize: '1.3rem',
    marginBottom: '0.5rem'
  },
  signatory: {
    fontFamily: 'Montserrat',
    fontSize: '1.5rem',
    fontWeight: '600'
  },
  validatorTitle: {
    width: '100%',
    textAlign: 'center',
    background: '#7eb95d',
    color: '#fff',
    fontFamily: 'Montserrat',
    fontSize: '1.5rem',
    fontWeight: '600',
    padding: '.8rem'
  },
  validatorTitleNotValid: {
    width: '100%',
    textAlign: 'center',
    background: '#af5751',
    color: '#fff',
    fontFamily: 'Montserrat',
    fontSize: '1.5rem',
    fontWeight: '600',
    padding: '.8rem'
  },
  vaMiddle: {
    verticalAlign: 'middle'
  },
  expansionPanel: {
    boxShadow: 'none',
    fontSize: '1rem'
  },
  expansionPanelTitle: {
    padding: '0 24px 0 6px'
  },
  expansionPanelContent: {
    padding: '8px 24px 24px 6px',
    fontWeight: '500'
  },
  expansionPanelContentBold: {
    fontWeight: '600'
  },
  btnicon: {
    marginRight: '0.6rem'
  },
  langSelect: {
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    textTransform: 'none',
    width: '20%',
    textAlign: 'right'
  },
  langSelectBtn: {
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    textTransform: 'none',
  }
}

const fileNameStyle = {
  paddingTop: '25px'
}
const fileIconStyle = {
  fontSize: '1.4rem',
  marginRight: '0.2rem',
  verticalAlign: 'middle',
  marginTop: '-4px'
}
const UploadAreaOuterStyle = {
  background: '#f9f9f9',
  padding: '1rem',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto 1rem',
  cursor: 'pointer',
  position: 'relative',
  minHeight: '168px',
  height: 'auto'
};

const UploadAreaInnerStyle = {
  border: '1px dashed #ccc',
  backgroundSize: '100px',
  paddingTop: '1rem',
  color: '#7C7C7C',
  minHeight: '140px',
  height: 'auto'
};

const uploadLogoStyle = {

}
/*
const DZBaseStyle = {
  width: 500,
  height: 150,
  borderWidth: 2,
  borderColor: '#666',
  borderStyle: 'dashed',
  borderRadius: 5,
  textAlign: 'center',
  margin: '0 auto',
  cursor: 'pointer',
}

const DZActiveStyle = {
  borderStyle: 'solid',
  borderColor: '#6c6',
  backgroundColor: '#eee',
}

const DZAcceptStyle = {
  borderStyle: 'solid',
  borderColor: '#00e676',
}

const DZrejectStyle = {
  borderStyle: 'solid',
  borderColor: '#ff1744',
}

 const DZUploadIconStyle = {
  display: 'block',
  fontSize: '90px',
  margin: '0 auto',
}
const UploadIconStyle = {
  display: 'block',
  width: '30px',
  margin: '0 auto',
} */

let FileToValidate;

function MyDropzone(state) {
  const [file, setFile] = useState({});
  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0] != null) {
      setFile(acceptedFiles[0]);
      FileToValidate = acceptedFiles[0];
      state.updateValidateButtonClass();
    } else {

    }
  }, [])
  const {
    getRootProps,
    getInputProps,
    isDragActive    
  } = useDropzone({ onDrop, accept: 'application/pdf' })

/*   const style = useMemo(() => ({
    ...DZBaseStyle,
    ...(isDragActive ? DZActiveStyle : {}),
    ...(isDragAccept ? DZAcceptStyle : {}),
    ...(isDragReject ? DZrejectStyle : {}),
  }), [
      isDragActive,
      isDragReject
    ]) */
  
  let textForDrop;
  if (file.name == null) {
    textForDrop =
      isDragActive ?
        <p>{strings.dragFile}</p> :
        <p>{strings.chooseFile}</p>;
  }
  else {
    state = true;
  }

  return (
    <div style={UploadAreaOuterStyle} className={`upload-area-outer`} {...getRootProps()}>
      <div style={UploadAreaInnerStyle}>
        {
          (file.name == null) ?
            <img src={UploadLogo} style={uploadLogoStyle} alt="{strings.uploadLogoAlt}"/> :
            <div style={fileNameStyle}>
              <p><FontAwesomeIcon icon={faFilePdf} style={fileIconStyle} /> {file.name}</p>
            </div>
        }
        <input {...getInputProps()} />
        {textForDrop}
      </div>
    </div>
  )
}

function getSignatoryLogo(logoFromBackend) {
  if (logoFromBackend === 'haagahelia') {
    if (strings.getLanguage() === 'en') {
      return HaagaHeliaLogoEn;
    } else {
      return HaagaHeliaLogo;
    }
  } else if (logoFromBackend === 'hamk') {
    return HamkLogo;
  } else if (logoFromBackend === 'laurea') {
    if (strings.getLanguage() === 'en') {
      return LaureaLogoEn;
    } else {
      return LaureaLogoFi;
    }
  } else if (logoFromBackend === 'oamk') {
    if (strings.getLanguage() === 'en') {
      return OamkLogoEn;
    } else {
      return OamkLogoFi;
    }
  } else if (logoFromBackend === 'kamk') {
    if (strings.getLanguage() === 'en') {
      return KamkLogoEn;
    } else {
      return KamkLogoFi;
    }
  } else if (logoFromBackend === 'novia') {
    if (strings.getLanguage() === 'en') {
      return NoviaLogoEn;
    } else {
      return NoviaLogoSv;
    }
  } else if (logoFromBackend === 'abo') {
    if (strings.getLanguage() === 'en') {
      return AboLogoEn;
    } else {
      return AboLogoSv;
    }
  }
  else if (logoFromBackend === 'xamk') {
    return XamkLogo;
  } else if (logoFromBackend === 'tamk') {
    return TamkLogo;
  } else if (logoFromBackend === 'seamk') {
    return SeamkLogo;
  } else if (logoFromBackend === 'lapinamk') {
    return LapinAMKLogo;
  } else if (logoFromBackend === 'turkuamk') {
    return turkuAMKLogo;
  } else if (logoFromBackend === 'centria') {
    return CentriaLogo;
  } else if (logoFromBackend === 'lab') {
    return LABLogo;
  } else if (logoFromBackend === 'vamk') {
    return VamkLogo;
  } else if (logoFromBackend === 'jamk') {
    return JamkLogo;
  } else if (logoFromBackend === 'humak') {
    return HumakLogo;
  } else if (logoFromBackend === 'karelia') {
    return KareliaLogo;
  } else if (logoFromBackend === 'dvv') {
    return DVVLogo;
  } else if (logoFromBackend === 'hyria') {
    return HyriaLogo;  
  } else if (logoFromBackend === 'savonia') {
    return SavoniaLogo;  
  } else if (logoFromBackend === 'samk') {
    return SamkLogo;  
  } else if (logoFromBackend === 'ouluyo') {
    return OuluyoLogo;  
  } else if (logoFromBackend === 'uniarts') {
    return UniartsLogo;
  } else if (logoFromBackend === 'diak') {
    return DIAKLogo;
  } else if (logoFromBackend === 'uef'){
    return UEFLogo;
  } else if (logoFromBackend === 'ulapland'){
    return UlaplandLogo;
  } else if (logoFromBackend === 'uwasa'){
    return UwasaLogo;
  } else if (logoFromBackend === 'bc'){
    return BCLogo;
  } else if(logoFromBackend === 'luksia'){
    return LuksiaLogo;
  } else if(logoFromBackend === 'omnia'){
    return OmniaLogo
  }else if(logoFromBackend === 'samiedu'){
    return SamieduLogo
  }else if(logoFromBackend === 'esedu'){
    return EseduLogo
  }else if(logoFromBackend === 'lappia'){
    return LappiaLogo
  }

  else {
    return null;
  }
}


function Results(props) {
  let signatory;
  const signinDate = props.results.signingDate === null ? 'N/A' : props.results.signingDate;
  let issuerCN = null;
  let issuerO = null;
  let subjectCN = null;
  const certificates = props.results.certificates == null ? [] : props.results.certificates.slice(1).reverse();

  const details = {
    certificates: certificates,
    subjectDN: props.results.subjectDN,
    signinDate: signinDate,
  }

  if (props.results.issuerDN !== undefined) {
    const splittedIssuerDN = props.results.issuerDN.split(',');
    splittedIssuerDN.forEach(element => {
      element = element.trim();
      if (element.substring(0, 3) === 'CN=') {
        issuerCN = element.substring(3);
      } else if (element.substring(0, 2) === 'O=') {
        issuerO = element.substring(2);
      }
    });
  }
  if (props.results.subjectDN !== undefined) {
    const splittedSubjectDn = props.results.subjectDN.split(',');
    splittedSubjectDn.forEach(element => {
      element = element.trim();
      if (element.substring(0, 3) === 'CN=') {
        subjectCN = element.substring(3);
      }
    });
  }
  const signatoryLogo = props.results.logo === "unknown" ? null : getSignatoryLogo(props.results.logo);
  const signatureValid = props.results.trusted && props.results.valid;

  if (signatureValid && signatoryLogo) {

    let logoHeader = <img className="logo" src={signatoryLogo} alt="{strings.signatoryLogoAlt}"/>;
    if(props.results.logo === 'dvv'){
      logoHeader = <span style={styles.vaMiddle}>{props.results.givenName} {props.results.surName}<br/>{props.results.organisation}</span>
    }

    signatory =
      <div id="results_head" >
        <div style={styles.validatorWrapper}><h2 id="signatory" style={styles.signatory} >{strings.signedBy}</h2>
          {logoHeader}
        </div>
        <h1 id="signature_valid" style={styles.validatorTitle}>
          <FontAwesomeIcon icon={faCheckCircle} style={styles.vaMiddle} className="signature_valid_icon" />
          &nbsp;<span style={styles.vaMiddle}>{strings.signatureIsValid}</span>
        </h1>
      </div>
  } else if (signatureValid && !signatoryLogo) {
    signatory =
      <div id="results_head" >
        <div style={styles.validatorWrapper}>
          <div className={`unknown-logo`}>
            <FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon> 
            <span>{strings.signedByUnknown}</span>
          </div>          
        </div>
        <h1 id="signature_valid" style={styles.validatorTitle}>
          <FontAwesomeIcon icon={faCheckCircle} style={styles.vaMiddle} className="signature_valid_icon" />
          &nbsp;<span style={styles.vaMiddle}>{strings.signatureIsValid}</span>
        </h1>
      </div>
  } else {
    signatory =
      <div id="results_head">
        <h1 id="signature_not_valid" style={styles.validatorTitleNotValid}>
          <FontAwesomeIcon icon={faTimes} style={styles.vaMiddle} className="signature_failed_icon" />
          &nbsp;
        <span style={styles.vaMiddle}>{strings.signatureIsNotValid}</span></h1>
      </div>
  }

  return (
    <div id="results">
      {signatory}
      <div id="results_body" style={styles.resultsWrapper}>
        {
          props.results.eidas &&
            <h2><FontAwesomeIcon icon={faCheckSquare} style={styles.vaMiddle} className={`valid_icon`} /> <span style={styles.resultText}>{strings.eidas}</span></h2> 
        }
        {
          props.results.lta &&
            <h2><FontAwesomeIcon icon={faCheckSquare} style={styles.vaMiddle} className={`valid_icon`} /> <span style={styles.resultText}>{strings.lta}</span></h2> 
        }
        {
          props.results.valid ?
            <h2><FontAwesomeIcon icon={faCheckSquare} style={styles.vaMiddle} className={`valid_icon`} /> <span style={styles.resultText}>{strings.documentNotModified}</span></h2> :
            <h2><FontAwesomeIcon icon={faTimes} style={styles.vaMiddle} className={`not_valid_icon`} /> <span style={styles.resultText}>{strings.documentModified}</span></h2>
        }
        {
          props.results.trusted ?
            <h2><FontAwesomeIcon icon={faCheckSquare} style={styles.vaMiddle} className={`valid_icon`} /> <span style={styles.resultText}>{strings.identityValid}</span></h2> :
            <h2><FontAwesomeIcon icon={faTimes} style={styles.vaMiddle} className={`not_valid_icon`} /> <span style={styles.resultText}>{strings.identityNotValid}</span></h2>
        }
        {props.results.test &&
          <h2 className="for_test_purposes">{strings.signatureForTest}</h2>
        }
        {/* <h1>Allekirjoituksen aikatiedot ovat peräisin allekirjoittajan tietokoneen kellosta</h1>
        <h1>Allekirjoitus tukee pitkäaikaista vahvistamista</h1> */}
        {signatureValid &&
          <div>
            <ResultDetails details={details}></ResultDetails>
            {/* <h3>Näytä tarkemmat tiedot</h3>
            <div>
              <p>
                Allekirjoitus on kelvollinen ja sen on tehnyt<br />
                <span className="bold">{subjectCN}</span>
              </p>
              <p>
                Allekirjoituksen aika<br />
                <span className="bold">{signinDate}</span>
              </p>
              <p>
                Dokumentti on peräisin luotettavasta lähteestä, jonka on varmentanut<br/>
                <span className="bold">{issuerCN}</span><br />
                <span className="bold">{issuerO}</span>
              </p>
            </div> */}
          </div>
        }
        <br />
        <Button style={styles.validateAgainButton} variant="contained" color="primary" onClick={props.clearValidation}>{strings.validateAnotherFile}</Button>
        
      </div>
    </div>
  )
}

function CertificateRow(props) {
  const classNameForRow = "row" + props.index;
  return (
    <span><span className={["bold", classNameForRow].join(" ")}><SubdirectoryArrowRight></SubdirectoryArrowRight>{props.certificate.subjectDN}</span><br /></span>
  );
}

function ResultDetails(props) {
  let certificates = "";
  props.details.certificates.forEach(function (certificate, index) {
    if (index === 0) {
      certificates = certificate.subjectDN + '<br />';
    } else {
      for (let i = 1; i < index; i++) {
        certificates += "&nbsp;&nbsp;";
      }
      certificates += '|_' + certificate.subjectDN;
    }
  });

  return (
    <div id="result_details_root">
      <ExpansionPanel style={styles.expansionPanel}>
        <ExpansionPanelSummary style={styles.expansionPanelTitle} expandIcon={<ExpandMoreIcon />}>
          {strings.detailedInformation}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={styles.expansionPanelContent}>
          <div>
            <p>
              {strings.signatureValidAndBy}<br />
              <span style={styles.expansionPanelContentBold}>{props.details.subjectDN}</span>
            </p>
            <p>
              {strings.signatureTime}<br />
              <span style={styles.expansionPanelContentBold}>{props.details.signinDate}</span>
            </p>
            <p id="certificates">
              {strings.documentFromTrustedSource}<br />
              {/* <span className="bold">{certificates}</span> */}
              {props.details.certificates.map((certificate, i) => <CertificateRow key={i} index={i} certificate={certificate}></CertificateRow>)}
            </p>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

function Loader(props){
  let str;
    { props.show === true ? 
       str = ''
       :
       str='none'
    }
    return (
      <div className="loader" style={{display: str}}>
          <div className="loader-container">
              <img id="atomi-loader" src={LoaderImg} alt="Logo" />
          </div>
      </div>
    )
}

class App extends Component {
  constructor(props) {
    const { classes } = props;
    super(props);
    this.state = {
      validated: false,
      validationResults: {},
      validateButtonClass: classes.disabledButton,
      validationInProgress: false,
    }
  }

  upload() {
    this.setState({
      validationInProgress:true,
    });
    const data = new FormData();
    // const file = document.querySelector('input[type="file"]').files[0];
    const file = FileToValidate;
    data.append("file", file);

    //fetch("http://localhost:8080/atomi", {
    fetch("https://validator-dot-atomi-226114.appspot.com/atomi", {
      //fetch("/atomi", {
      method: "POST",
      body: data
    }).then(response => response.json())
      .then(response => {
        this.setState((state) => {
          return {
            validated: true,
            validationResults: response,
            validationInProgress: false,
          }
        });

      })
      .catch(error => {
        this.setState({
          validationInProgress:false,
        });
      });
  }

  setLanguage(language) {
    const currentLang = strings.getLanguage();
    if (currentLang !== language){
      if (language === 'en') {
        strings.setLanguage('en');
      } 
      else if (language === 'sv') {
        strings.setLanguage('sv');
      } 
      else {
        strings.setLanguage('fi');
      }
    }
    this.setState({});
  }

  clearValidation() {
    this.setState((state) => {
      return {
        validated: false,
        validationResults: {},
      }
    });
  }

  updateValidateButtonClass() {
    const { classes } = this.props;
    this.setState({ validateButtonClass: FileToValidate == null ? classes.disabledButton : classes.validateButton });
  }

  render() {
    document.title = "Atomi Validator";
    const { classes } = this.props;

    return (
      <div id="validator">
        {/* <ResultDetails></ResultDetails> */}
        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <div className={`${classes.naviLeft} naviLeft`}>
              {this.state.validated &&
                <FontAwesomeIcon icon={faArrowLeft} className="back_button" onClick={this.clearValidation.bind(this)}></FontAwesomeIcon>
              }
            </div>
            <div className={`${classes.grow} ${classes.appName} naviCenter`}>
              <img className={`${classes.appLogo}`} src={AtomiLogo} alt="ATOMI logo" height="50" />
            </div>
            <div className={`${classes.langSelect} naviRight`}>
              <LanguageMenu className={classes.langSelectBtn} strings={strings} setLanguage={this.setLanguage.bind(this)}></LanguageMenu>
            </div>
          </Toolbar>
        </AppBar>
        {
          this.state.validated ?
            <Results results={this.state.validationResults} clearValidation={this.clearValidation.bind(this)}></Results> :

            <div className={classes.validatorWrapper}>
              {/* <p>Tarkista sähköisesti allekirjoiteut dokumentit nopeasti ja helposti.</p> */}
              
              <Loader show={this.state.validationInProgress}></Loader>
              
              <p className={classes.infotext1}>{strings.infotext}</p>

              <MyDropzone updateValidateButtonClass={this.updateValidateButtonClass.bind(this)}></MyDropzone>

              <Button className={this.state.validateButtonClass} disabled={(this.state.validateButtonClass === classes.disabledButton)} variant="contained" color="primary" onClick={this.upload.bind(this)}>
                <FontAwesomeIcon icon={faCheck} className={classes.btnicon} />
                {strings.validateFile}</Button>
              <p className={classes.infotext2}> {strings.dataCollectingInfo} <PrivacyPolicyDialog strings={strings} linkTextId='readMore'></PrivacyPolicyDialog></p>
            </div>
        }
        <div id="footer">
          <a href={studyoUrl} target="_blank" rel="noopener noreferrer"><img src={PoweredBy} alt="Powered by Studyo" /></a>
          <p className={ (this.state.validated ? 'show' : 'hide') }><PrivacyPolicyDialog strings={strings} linkTextId='privacyPolicy'></PrivacyPolicyDialog></p>
        </div>

      </div>
    );
  }
}

export default withStyles(styles)(App);
